import React, { FC } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';
import { Typography } from '@material-ui/core';

import { getHighlight } from './apiQueries';
import HighlightDetails from './HighlightDetails';

const Highlight: FC = () => {
	const { id }: HighlightParams = useParams();

	const { loading, error, data } = useQuery(getHighlight, {
		variables: { id: decodeURIComponent(id) }
	});

	if (loading) return <Typography>Loading...</Typography>;
	if (error) return <Typography>Error loading data from the server</Typography>;
	if (!data.getHighlight) return <Typography>No highlight found</Typography>;

	const { available, availableTime, drm, game, gameId, periods, publishTime, sources, type, videoAssets } = data.getHighlight;

	return (
		<HighlightDetails
			available={available}
			availableTime={availableTime}
			drm={drm}
			game={game}
			gameId={gameId}
			id={id}
			periods={periods}
			publishTime={publishTime}
			sources={sources}
			sport={game?.sport}
			type={type}
			videoAssets={videoAssets}
		/>
	);
};

type HighlightParams = { id: string };

export default Highlight;
